<div class='loader-wrapper'>
  <!-- hide wrapped spinner if full page is visible -->
  <div class="spinner-loader-container" *ngIf="!loaderSpinnerService.displaySpinner && loaderSpinnerService.displayWrappedSpinner">
    <div class='spinner-wrapper'>
      <mat-progress-spinner
        attr.aria-label="{{ 'application_features.loading' | translate }}"
        class="mat-spinner-color spinner-styling"
        mode="indeterminate"
        value="50">
      </mat-progress-spinner>
    </div>
  </div>
  <div class='spinner-overlay' *ngIf="!loaderSpinnerService.displaySpinner && loaderSpinnerService.displayWrappedSpinner"></div>
  <ng-content></ng-content>
</div>
